import setSlideHeight from './setSlideHeight';

// Runs validation to ensure all fields conform to the validation requirements and regex rules.
const isFormValid = function() {
    const activeForm = $('.membership-body:not(.inactive)');
    // Keeps track of the validation state of the form to return for the outcome.
    var isValid = true;
    var firstInvalidField = '';
    $(".membership-slides-slide.active .validation-error").addClass("hidden");

    // Loop through each field and apply validation rules to it.
    activeForm.find(".membership-slides-slide.active .form-row").each(function() {
        var error = $(this).find(".validation-error");

        // If there is a validation error
        if (error.length) {
            var fieldValue = '';

            // Determine the type of field we are validating
            if($(this).find(".datepicker").length){
                fieldValue = $(this).find(".datepicker").val();
            }else if ($(this).find(".form-select-input").length) {
                fieldValue = $(this).find(".form-select-input").val();
            } else if ($(this).find(".form-textfield-input").length) {
                fieldValue = $(this).find(".form-textfield-input").val();
            } else if ($(this).find("input[type=radio]").length) {
                var radios = $(this).find("input[type=radio]");
                for (var i = 0; i < radios.length; i++) {
                    if (radios[i].checked == true) {
                        fieldValue = 'checked';
                    }
                }
            } else if ($(this).find("input[type=checkbox]").length) {
                var checkbox = $(this).find("input[type=checkbox]");
                for (var i = 0; i < checkbox.length; i++) {
                    if (checkbox[i].checked == true) {
                        fieldValue = 'checked';
                    }
                }
            } else if ($(this).find("input[type=file]").length) {
                fieldValue = $(this).find("input[type=file]").val();
            }

            for (var i = 0; i < error.length; i++) {
                var valid = true;
                // If this is a required field AND there is no field value, set to not valid.
                if ($(error[i]).data("required") && fieldValue == '') {
                    valid = false;

                } else if ($(error[i]).data("validation-rule") && fieldValue != '') {
                    // If the error has a validation rule AND the field value is not empty, test the validation rule.
                    // Otherwise it will test the validation rule on optional fields with nothing in them - bad!
                    var rule = new RegExp($(error[i]).data("validation-rule"));
                    if (!rule.test(fieldValue)) {
                        valid = false;
                    }
                }

                // If the fieldValue is not valid, show the error.
                if (!valid) {
                    $(error[i]).removeClass('hidden');
                    // If we haven't already assigned a first invalid field, then do it here.
                    if (firstInvalidField == '') {
                        firstInvalidField = $(this);
                    }
                    isValid = false;
                    return;
                }
            }
        }
    });
    // Animate the page to the position of the first invalid field.
    if (firstInvalidField) {
        $('html,body').animate({ scrollTop: $(firstInvalidField).offset().top - 140 }, 1000);
    }
    setSlideHeight();
    return isValid;
};

export default isFormValid;